import httpClient from "http-client/http-client";

export async function proxyLogin({ phone_number, otp }) {
  const { data, errors } = await httpClient.post({
    url: "v1/community-portal/auth/proxy-login",
    body: {
      phone_number: String(phone_number || "").trim(),
      otp: String(otp || "").trim(),
    },
  });
  if (errors && errors.length > 0) return { data: null, errors };
  return { data };
}
